import request from '@/assets/scripts/utils/request';

// 登录 获取验证码
export function sendVerify(data) {
    return request({
        url: '/account/sendverify',
        method: 'post',
        data
    });
}

// 登录 获取可发送短信的国家列表
export function country(params) {
    return request({
        url: '/Account/country',
        method: 'get',
        params
    });
}

// 登录 登录
export function login(data) {
    return request({
        url: '/account/login',
        method: 'post',
        data
    });
}

// 登录 验证用户密码是否正确
export function getMobileStatus(data) {
    return request({
        url: '/account/getMobileStatus',
        method: 'post',
        data
    });
}

// 登录 验证用户密码是否正确
export function getMobileStatusRe(data) {
    return request({
        url: '/account/getMobileStatusRe',
        method: 'post',
        data
    });
}

// 登录 找回密码
export function findpass(data) {
    return request({
        url: '/Account/findpass',
        method: 'post',
        data
    });
}

// 登录 注册
export function register(data) {
    return request({
        url: '/account/register',
        method: 'post',
        data
    });
}

// 登录 获取修改手机号的短信验证码
export function sendUcenterVerify(params) {
    return request({
        url: '/Ucenter/sendverify',
        method: 'post',
        params
    });
}

// 登录 更改手机号
export function modifymobile(params) {
    return request({
        url: '/Ucenter/modifymobile',
        method: 'post',
        params
    });
}

// 登录 验证用户密码是否正确
export function checkpass(params) {
    return request({
        url: '/Ucenter/checkpass',
        method: 'post',
        params
    });
}



